module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="assetTooltip">\n    <div class="image-wrapper">\n        <div class="image-container">\n            ';
 if (isScene7) { ;
__p += ' <div class="adobe-logo"></div> ';
 } ;
__p += '\n            <img src="' +
__e( absoluteThumbUrl ) +
'" class="image" title="' +
__e( name ) +
'">\n        </div>\n    </div>\n\n    <div class="image-info">\n        <div class="title">' +
__e( name );
 if (timesUsed > 0) { ;
__p += ' <span class="times-used">(' +
__e( timesUsed ) +
')</span> ';
 } ;
__p += '</div>\n        <div>\n            Alt text: ' +
__e( altText ) +
'\n        </div>\n        <div class="description">\n            <ul>\n                <li>Size: ' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</li>\n                ';
 if (showExtension) { ;
__p += '\n                    <li>Type: ' +
__e( extension ) +
'</li>\n                ';
 } ;
__p += '\n                ';
 if (showTags) { ;
__p += '\n                    <li>\n                        <div class="imageTagsRegion"></div>\n                    </li>\n                ';
 } ;
__p += '\n            </ul>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/image/ImageTooltipView.tpl
// module id = 1737
// module chunks = 0